import React from 'react';
import styled from 'styled-components';

function Card({
   account, amount, text, button, card, active, inactive, check,
 text1, text2, text3, text4, text5, text6, link
}) {
   return (
      <CardStyled >
         <h4 className="card-title">
            {account}
         </h4>
         <h4 className="card-title">
            {amount} <span></span>
         </h4>
         <p className="c-para">{text}</p>
         <div className="button-con">
         <a href={link} target="_blank" rel="noopener noreferrer">
               <button>{button}</button>
               </a>
         </div>
         <div className="card-image-con">
            <img src={card} alt="" />
         </div>
         <div className="plan-con">
            <img src={active} alt="" />
            <img src={inactive} alt="" />
         </div>
         <div className="list-con">
            <p className="text-check">
               <img src={check} alt="" />
               {text1}
            </p>
            <p className="text-check">
               <img src={check} alt="" />
               {text2}
            </p>
            <p className="text-check">
               <img src={check} alt="" />
               {text3}
            </p>
            <p className="text-check">
               <img src={check} alt="" />
               {text4}
            </p>
            <p className="text-check">
               <img src={check} alt="" />
               {text5}
            </p>
            <p className="text-check">
               <img src={check} alt="" />
               {text6}
            </p>
            {/* <p className="text-check">
               <img src={checkDis} alt="" />
               {text7}
            </p>
            <p className="text-check">
               <img src={checkDis} alt="" />
               {text8}
            </p> */}
         </div>
      </CardStyled >
   )
}

const CardStyled = styled.div`
    background-color: white;
    padding: 3rem 2rem;
    border-radius: 50px;
    box-shadow: 0px 25px 50px rgba(22, 25, 79, 0.05);
    .card-title{
        font-size: 1.7rem;
        color: #000;
        text-align: center;
        padding: 1.5rem 0;
        span{
            font-size: 1.1rem;
        }
    }
    .button-con{
        text-align: center;
        padding: 1.4rem 0;
        button{
            border: 2px solid #16194F;
            padding: .6rem 1.5rem;
            outline: none;
            cursor: pointer;
            background: transparent;
            border-radius: 20px;
            font-size: inherit;
            color: #16194F;
        }
    }
    .card-image-con{
        display: flex;
        justify-content: center;
        img{
            width: 70%;
        }
    }
    .plan-con{
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 1.4rem 0;
        img{
            padding: 0 .2rem;
        }
    }
    .text-check{
        display: flex;
        align-items: center;
        padding: .3rem 0;
        font-size: 1.1rem;
        img{
            padding-right: .3rem;
            width: 24px;
        }
       
    }
`;
export default Card;